export enum AuthRoutes {
  blank = '/',
  notDefinedRoute = '/*',
  addPort = '/add/port',
  addBandwidth = '/add/link',
  dashboard = '/dashboard',
  myNetworkMapView = '/dashboard/my-network-map',
  userVerification = '/admin/user/verification',
  portVerification = '/admin/port/verification',
  bandwidthVerification = '/admin/link/verification',
  managePorts = '/manage/ports',
  manageBandwidth = '/manage/link',
  marketPlacePorts = '/marketplace/ports',
  marketPlaceBandwidth = '/marketplace/links',
  marketPlaceBandwidthMap = '/marketplace/links', // '/marketplace/links/map',
  wxPay = '/pay',
  reports = '/pay/reports',
  crossConnectValidation = '/admin/cross-connect/verification',
  deletePorts = '/admin/delete/ports',
  deleteBandwidthPorts = '/admin/delete/bandwithports',
  about = '/about',
  adminScripts = '/admin-scripts',
  account = '/account',
  privateNode = '/private-node',
  privateNodeRequestStatus = "/private-node/status"
}

export enum CCStatus {
  none = 'none',
  dotted = 'dotted',
  grey = 'grey',
  green = 'green',
}

export enum PortStatus {
  bought = 'bought',
  sold = 'sold',
  verified = 'verified',
  unverified = 'unverified',
  listed = 'listed',
}

export enum NonAuthRoutes {
  login = '/login',
  register = '/register',
  requestQuote = '/request-quote', 
  registerPrivateNode = '/register/private-node',
  loginPrivateNode = '/login/private-node'
}

export enum Roles {
  admin = 'wxadmin',
  user = 'enterpriseUser'
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}
